const KEY = 'navState';

export function setNavState(value: unknown) {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify(value));
  } catch {}
}

export function getNavState<T = unknown>(): T | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function clearNavState() {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(KEY);
}
